import { render, staticRenderFns } from "./Board.vue?vue&type=template&id=88eb0162&scoped=true&"
import script from "./Board.vue?vue&type=script&lang=js&"
export * from "./Board.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88eb0162",
  null
  
)

export default component.exports